import _ from "lodash";
import {UsersIcon} from "lucide-react"
import ScrollArea from 'react-scrollbar'

import { User } from "./user";
import {useConectaPro} from "../../../../store/service-activation/useConectaPro";

export function UserList(){
  const users = useConectaPro(st=>st.data.users)

  return(
    <div className="flex flex-col gap-4 w-full p-4 bg-white rounded border border-zinc-200/40 shadow">
      <div className="flex flex-col gap-6 px-2 ">
        <h1 className="flex gap-4 items-center justify-start">
          <UsersIcon className="w-6 h-6 text-scale-600" />
          <span className="text-lg font-semibold text-scale-600">Usuários</span>
        </h1>
      </div>
      <div className="flex flex-col max-h-72 h-fit gap-6">
        <ScrollArea smoothScrolling horizontal={false} className="w-full h-full pr-2">
          <div className="flex flex-col gap-2 group h-full w-full">
            {Object.entries(users).map(([key]) => <User key={key} userKey={key} />)}
            {!_.size(users) && (
              <div className="flex flex-col w-full items-center justify-center p-1 gap-2">
                <p className="text-center w-full">Para ativar o <strong className="font-bold">Conecta Pro</strong> na sua unidade, você precisa instalar a extensão clicando <a href="https://chromewebstore.google.com/detail/petland-crm-assistent/mcjmigdilehdcdkbkhjhicgmkpebcobl?authuser=2&hl=pt-BR&pli=1" target="_blank" rel="noreferrer" className="text-scale-500 hover:underline">aqui</a>, cadastrar o usuário e validar o acesso.</p>
                <p className="text-center w-full">Você receberá um <strong className="font-bold">SMS</strong> com o código de confirmação, e esse código também será exibido aqui na tela para você inserir na aba <strong className="font-bold">Conecta Pro</strong>.</p>
              </div>
            )}
          </div>
        </ScrollArea>
      </div>
    </div>
  )
}
